module.exports = __webpack_public_path__ + "media/images/river_and_mountain-fc0fba5b.webp";